import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import TableCell from '@material-ui/core/TableCell';

const HistoryType = (props) => {
    let properties = {...props};
    if (!properties.placement) {
        properties.placement = 'left';
    }

    const getTitle = () => {
        switch (props.type) {
            case '+':
                return 'Объект добавлен';
            case '~':
                return (props.changes && Object.keys(props.changes).length > 0) ? 'Объект изменен' : 'Объект сохранен';
            case '-':
                return 'Объект удален';
            default:
                return 'Неизвестный тип';
        }
    };

    // noinspection JSValidateTypes
    return (
        <Tooltip title={getTitle()} arrow={true} {...properties}>
            {(props.children)
                ? props.children
                : <span>{props.type}</span>
            }
        </Tooltip>
    );
};

HistoryType.propTypes = {
    type: PropTypes.string.isRequired,
    changes: PropTypes.object,
};

HistoryType.defaultProps = {
};

export default HistoryType;
